@if (loading) {
  <div class="loader"></div>
}
<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      @if (!element.purchase_order) {
        <h1>{{'Add' | translate}}</h1>
      }
      @if (element.purchase_order) {
        <h1>{{'Edit' | translate}}</h1>
      }
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="row">
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Purchase order' | translate}}**</label>
            <input type="text" [(ngModel)]="values.purchase_order" name="purchase_order" placeholder="{{'Insert text' | translate}}" required>
          </div>
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="submit" type="submit" value="{{ 'Save' | translate}}" [disabled]="form.invalid">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>